import React from 'react';
import { Link } from 'react-router-dom';

export default function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <Link to="/" className="text-cyan-500 underline mb-6 inline-block">← Back to Home</Link>
      <h1 className="text-3xl font-bold mb-4">Disclaimer</h1>
      <p className="mb-4">
        The information provided by V Adithya Pvt. Ltd. is for general informational purposes only. All information is provided in good faith, however we make no representation or warranty of any kind.
      </p>
      <p className="mb-4">
        Under no circumstance shall we be liable for any loss or damage incurred as a result of using this site.
      </p>
      <p className="mb-4">
        We reserve the right to modify or update this disclaimer at any time.
      </p>
    </div>
  );
}
